<!--
 - List attachments component
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @author Deitric Jang <djang@buildcentrix.com>
 - @copyright (c) 2022-2023 Build Centrix
 -->
<div class="order-attachments">
  <!--Attachments-->
  <div
    class="order-attachments-list"
    *ngIf="attachments?.length > 0"
    [ngClass]="{ 'full-height': attachmentsListSelections.selected.length === 0 }"
  >
    <div class="attachments-list container-fluid attachments-header">
      <div class="row">
        <div class="col p-0">
          <div class="attachment-select header">
            <mat-checkbox
              (change)="$event ? toggleAllCheckboxes() : null"
              disableRipple="true"
              [checked]="attachmentsListSelections.hasValue() && isAllSelected()"
              [indeterminate]="attachmentsListSelections.hasValue() && !isAllSelected()"
              [aria-label]="setCheckboxLabel()"
              [color]="'primary'"
            ></mat-checkbox>
          </div>
          <div
            class="attachment-label header"
            title="{{ 'order.attachments.table.description' | translate }}"
          >
            {{ 'order.attachments.table.title' | translate }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="attachments-list container-fluid attachments-body"
      *ngFor="let item of attachments"
    >
      <div class="row">
        <div class="col p-0">
          <div class="attachment-select body">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? attachmentsListSelections.toggle(item) : null"
              disableRipple="true"
              [checked]="attachmentsListSelections.isSelected(item)"
              [aria-label]="setCheckboxLabel(item)"
              color="primary"
            ></mat-checkbox>
          </div>
          <div class="attachment-label body">
            <div class="text-left title-column">
              <div class="title" title="{{ item.originalFileName }}">
                {{ item.originalFileName }}
              </div>
              <div class="description text-info" title="{{ item.description }}">
                {{ item.description }}
              </div>
            </div>
            <div class="text-center button-column">
              <!-- Attachment Context Menu (Download, Edit, Remove) -->
              <bc-atoms-button
                [label]="'labels.options.title' | translate"
                [title]="'labels.options.title' | translate"
                [iconOnly]="true"
                type="link"
                icon="all"
                display="block"
                size="small"
                [loading]="item.isRemoving"
                [disabled]="item.isRemoving"
              >
                <div dropdown-content>
                  <!-- Attachment context menu: Download Attachment -->
                  <div class="dropdown-item">
                    <a href="{{ item.url }}" target="_blank">
                      <bc-atoms-icon type="download"></bc-atoms-icon>
                      <label>{{ 'actions.download' | translate }}</label>
                    </a>
                  </div>
                  <!-- Attachment context menu: Edit Attachment -->
                  <div
                    class="dropdown-item"
                    (click)="onEditFile(item)"
                    *ngIf="wdEnvironmentService.permissions.canEditOrderDetails"
                  >
                    <a>
                      <bc-atoms-icon type="edit"></bc-atoms-icon>
                      <label>{{ 'actions.edit' | translate }}</label>
                    </a>
                  </div>
                  <!-- Attachment context menu: Remove Attachment -->
                  <div
                    class="dropdown-item"
                    *ngIf="wdEnvironmentService.permissions.canEditOrderDetails"
                  >
                    <bc-atoms-button
                      [label]="'actions.remove' | translate"
                      [title]="'actions.remove' | translate"
                      [loading]="item.isRemoving"
                      type="linkDanger"
                      icon="delete"
                      display="block"
                      size="small"
                      [confirmTitle]="
                    'actions.removeType'
                      | translate
                        : {
                            type: 'order.details.attachments.title' | translate
                          }
                  "
                      (onButtonClicked)="onRemoveFile(item)"
                    >
                      <div confirmation-body>
                        <div>
                          {{ 'prompts.confirmDeleteType' | translate: { type:
                          item.originalFileName } }}
                        </div>
                      </div>
                    </bc-atoms-button>
                  </div>
                </div>
              </bc-atoms-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--None Found Message-->
  <div
    class="none-found"
    *ngIf="attachments?.length === 0"
    [ngClass]="{ 'full-height': attachmentsListSelections.selected.length === 0 }"
  >
    <div class="none-found-message">
      {{'order.attachments.notFound'|translate}}
    </div>
  </div>
  <!--Download Attachments-->
  <div
    class="attachment-download"
    *ngIf="attachmentsListSelections.selected.length > 0"
  >
    <div class="download-button">
      <bc-atoms-button
        label="{{ 'actions.download' | translate }}"
        title="{{ 'actions.download' | translate }}"
        icon="download"
        display="block"
        size="small"
        [loading]="false"
        (onButtonClicked)="downloadMultipleFiles()"
      >
      </bc-atoms-button>
    </div>
  </div>
</div>
